import { PaletteOptions } from '@mui/material';

export const lightPalette: PaletteOptions = {
    mode: 'light',
    primary: {
        main: '#2196f3',
        light: '#64b5f6',
        dark: '#1976d2',
    },
    secondary: {
        main: '#f50057',
        light: '#ff4081',
        dark: '#c51162',
    },
    background: {
        default: '#ffffff',
        paper: '#f5f5f5',
    },
    text: {
        primary: 'rgba(0, 0, 0, 0.87)',
        secondary: 'rgba(0, 0, 0, 0.6)',
    },
    error: {
        main: '#f44336',
        light: '#e57373',
        dark: '#d32f2f',
    },
    warning: {
        main: '#ff9800',
        light: '#ffb74d',
        dark: '#f57c00',
    },
    success: {
        main: '#4caf50',
        light: '#81c784',
        dark: '#388e3c',
    },
};

export const darkPalette: PaletteOptions = {
    mode: 'dark',
    primary: {
        main: '#90caf9',
        light: '#e3f2fd',
        dark: '#42a5f5',
    },
    secondary: {
        main: '#f48fb1',
        light: '#fce4ec',
        dark: '#f06292',
    },
    background: {
        default: '#121212',
        paper: '#1e1e1e',
    },
    text: {
        primary: '#ffffff',
        secondary: 'rgba(255, 255, 255, 0.7)',
    },
    error: {
        main: '#f44336',
        light: '#e57373',
        dark: '#d32f2f',
    },
    warning: {
        main: '#ffa726',
        light: '#ffb74d',
        dark: '#f57c00',
    },
    success: {
        main: '#66bb6a',
        light: '#81c784',
        dark: '#388e3c',
    },
};